module.exports = __webpack_public_path__ + "static/media/icon-skins-selected.92b3ff51.svg";